import { TOP_AVATARS } from '@/constants/avatar';

export const getRandomTopAvatar = () => {
  return TOP_AVATARS[Math.floor(Math.random() * TOP_AVATARS.length)];
};
